import clsx from "clsx";
import { Link } from "react-router-dom";
import type { MoncoLogoLinkProps } from "./types";

const MONCO_LOGO_SRC = "/monco-logo-black.png";

export const MoncoLogoLink = ({ to = "/", className }: MoncoLogoLinkProps) => (
  <Link to={to}>
    <img
      src={MONCO_LOGO_SRC}
      alt="Monco.ai"
      className={clsx(
        "cursor-pointer hover:opacity-80 transition-opacity",
        className,
      )}
    />
  </Link>
);
